<template>
  <div class="c-pay-message">
    <div class="image-place">
      <img :src="success?imgPaySuccess:imgPayError" alt="">
    </div>
    <div class="message">
      <h3>{{ success ? 'Оплата прошла успешно': 'Оплата не прошла' }}</h3>
      <div class="price-place">
        <p>{{ payObj.cost }}</p>
        <div class="image-place">
          <img :src="imgCoin" alt="">
        </div>
      </div>
      <p>{{ payObj.message }}</p>
    </div>
  </div>
</template>

<script>
import imgPaySuccess from 'assets/payement/pay-success.svg'
import imgPayError from 'assets/payement/pay-error.svg'
import imgCoin from 'assets/main/shop/coin-black.svg'

export default {
  name: 'CPayMessage',
  props: {
    success: {
      type: Boolean,
      required: true,
    },
    payObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgPaySuccess,
      imgPayError,
      imgCoin,
    }
  },
  watch: {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.c-pay-message {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .image-place {
    width: 80px;
    height: 80px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .message {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h3 {
      margin-bottom: 12px;
      font-size: 1.5em;
    }
    .price-place {
      display: flex;
      align-items: center;

      p {
        margin-top: 0;
        color: var(--secondary);
        font-size: 1.5em;
      }
      .image-place {
        margin-left: 5px;
        width: 28px;
        height: 28px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    p {
      margin-top: 16px;
      font-size: 0.95em;
      color: #6D6F7B;
      text-align: center;
    }
  }
}
</style>
